import React, { useEffect, useState } from 'react';
import { Menu, X, Monitor, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../context/LanguageContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'pl' : 'en');
  };
  const navItems = [{
    label: t.nav.portfolio,
    id: 'portfolio'
  }, {
    label: t.nav.about,
    id: 'about'
  }, {
    label: t.nav.contact,
    id: 'contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-slate-950/80 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-126">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="flex items-center justify-between" data-id="element-128">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer group" onClick={() => scrollToSection('hero')} data-id="element-129">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-cyan-400 to-blue-600 flex items-center justify-center text-slate-950 shadow-lg group-hover:scale-105 transition-transform duration-300" data-id="element-130">
              <Monitor size={20} strokeWidth={2.5} data-id="element-131" />
            </div>
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-132">
              Quick<span className="text-cyan-400" data-id="element-133">Designs</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-134">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-sm font-medium text-slate-300 hover:text-cyan-400 transition-colors" data-id="element-135">
                {item.label}
              </button>)}

            {/* Language Switcher */}
            <button onClick={toggleLanguage} className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-slate-800/50 border border-slate-700 text-slate-300 hover:text-cyan-400 hover:border-cyan-400/50 transition-all text-sm font-medium" data-id="element-136">
              <Globe size={16} data-id="element-137" />
              {language.toUpperCase()}
            </button>

            <Button variant="primary" size="sm" onClick={() => scrollToSection('contact')} data-id="element-138">
              {t.nav.bookCall}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-139">
            {isMobileMenuOpen ? <X size={24} data-id="element-140" /> : <Menu size={24} data-id="element-141" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-slate-950 border-b border-white/5 p-4 flex flex-col gap-4 shadow-2xl" data-id="element-142">
          {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-left text-lg font-medium text-slate-300 hover:text-cyan-400 py-2" data-id="element-143">
              {item.label}
            </button>)}

          {/* Mobile Language Switcher */}
          <button onClick={toggleLanguage} className="flex items-center gap-2 py-2 text-lg font-medium text-slate-300 hover:text-cyan-400" data-id="element-144">
            <Globe size={20} data-id="element-145" />
            {language === 'en' ? 'English' : 'Polski'}
          </button>

          <Button variant="primary" className="w-full" onClick={() => scrollToSection('contact')} data-id="element-146">
            {t.nav.bookCall}
          </Button>
        </div>}
    </nav>;
}